export default {
	COOKIES: {
		SURVEY_SUBMITTED: "exit-survey-submitted",
		SURVEY_CLOSED_EXPIRATION_TIME: "survey-closed-expiration-time",
		SURVEY_SUBMITTED_EXPIRATION_TIME: "exit-survey-submitted-expiration-time"
	},
	PROMOS: {
		BANNER: {
			ALL: 1,
			ALL_BUT_HOME: 2,
			ONLY_HOME: 3,
			ALL_BUT_MOBILE_CONFIG: 4,
			ALL_BUT_REFURB_BUILDS: 9,
			ALL_BUT_MOBILE_CONFIG_REFURB_BUILDS: 10,
			ONLY_REFURB_BUILDS: 11
		}
	},
	SITES: {
		LETSBLD: 2
	},
	PERIPHERALS: {
		KEYBOARD: 1,
		MOUSE: 2,
		HEADSET: 3,
		MOUSEPAD: 4,
		OTHER: 5
	},
	STARTERPCSERIES: {
		TITLE: "Starter PC Series"
	},
	STARTERPC: {
		TITLE: "Starter PC"
	},
	STREAMERPC: {
		TITLE: "Streaming PC"
	},
	CREATORPC: {
		TITLE: "Creator PC"
	},
	H1MINIPC: {
		TITLE: "H1 MINI PC"
	},
	CHRISTMAS_PROMO: {
		PHASES: [
			{
				from: "2019-12-12 06:00:00",
				to: "2019-12-13 23:59:59"
			},
			{
				from: "2019-12-14 00:00:00",
				to: "2019-12-17 23:59:59"
			},
			{
				from: "2019-12-18 00:00:00",
				to: "2019-12-19 23:59:59"
			},
			{
				from: "2019-12-20 00:00:00",
				to: "2019-12-27 23:59:59"
			}
		]
	},
	COVID_19: false,
	FPS_PENDING_MESSAGE: "We are testing this configuration now so that we can share accurate FPS data with you."

};

export const PROMO_SALES = {
	TIME_ZONE: "America/Los_Angeles",
	PHASES: [
		{
			from: "2020-12-24 09:00:00",
			to: "2020-12-31 23:59:59"
		}
		// ,
		// {
		// 	from: "2020-12-18 00:00:00",
		// 	to: "2020-12-20 23:59:59"
		// }
	],
	DISCOUNT_ITEM_NAME: "NZXT H510",
	DISCOUNT_PRICE: 69.99
};
